import React from 'react';
import { useNavigate } from 'react-router-dom';
import AdminHeader from '../../../components/ui/AdminHeader';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AdminSettingsPage = () => {
  const navigate = useNavigate();

  const user = {
    name: "Admin User",
    role: "Platform Administrator"
  };

  return (
    <div className="min-h-screen bg-background">
      <AdminHeader
        title="System Settings"
        description="Configure platform settings and system preferences"
        user={user}
      />

      <main className="p-6">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="mb-6">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
                <Icon name="Settings" size={20} color="white" />
              </div>
              <div>
                <h2 className="text-xl font-semibold text-foreground">Configuration</h2>
                <p className="text-sm text-muted-foreground">System settings and platform configuration</p>
              </div>
            </div>
          </div>

          <div className="bg-card rounded-lg border border-border p-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-primary rounded-lg flex items-center justify-center mx-auto mb-4">
                <Icon name="Settings" size={32} color="white" />
              </div>
              <h3 className="text-xl font-semibold text-foreground mb-2">System Settings</h3>
              <p className="text-muted-foreground mb-6">
                This page is under development. System configuration functionality will be available soon.
              </p>
              <Button
                onClick={() => navigate('/admin-portal-dashboard')}
                iconName="ArrowLeft"
              >
                Back to Admin Portal
              </Button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AdminSettingsPage;